import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { withTranslation } from "react-i18next";
import { GLOBAL_STAFF_HELP_ITEMS, OFFICE_STAFF_HELP_ITEMS } from "constants";
import crossIcon from "../../../../assets/images/cross.svg";
import styles from "../../staff.module.scss";

const StaffHelpGuide = ({ isOpen, onClose, t, globalStaffPage = false }) => {
  const helpItems = globalStaffPage
    ? GLOBAL_STAFF_HELP_ITEMS
    : OFFICE_STAFF_HELP_ITEMS;
  return (
    <Modal
      isOpen={isOpen}
      toggle={() => onClose(false)}
      className="modal-md modal-dialog-centered modal-lg"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={() => onClose(false)}>
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <p className="title">{t("helpGuide")}</p>
        <div className={styles.modal_container}>
          <h5 className={styles.title_style}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.00039 1.8999C9.16039 1.8999 10.1004 2.8399 10.1004 3.9999C10.1004 5.1599 9.16039 6.0999 8.00039 6.0999C6.84039 6.0999 5.90039 5.1599 5.90039 3.9999C5.90039 2.8399 6.84039 1.8999 8.00039 1.8999ZM8.00039 10.8999C10.9704 10.8999 14.1004 12.3599 14.1004 12.9999V14.0999H1.90039V12.9999C1.90039 12.3599 5.03039 10.8999 8.00039 10.8999ZM8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0ZM8 9C5.33 9 0 10.34 0 13V15C0 15.55 0.45 16 1 16H15C15.55 16 16 15.55 16 15V13C16 10.34 10.67 9 8 9Z"
                fill="#587E85"
              />
            </svg>

            {t("staff.staffListOverview")}
          </h5>
          {globalStaffPage ? (
            <p>{t("staff.globalStaffHelpDescription")}</p>
          ) : (
            <p>{t("staff.staffHelpDesc")}</p>
          )}
          <ul>
            {helpItems.map((item, index) => (
              <li key={index}>
                <span className={styles.title_style}>{item.title}</span>
                <p>
                  {item.description}
                  {item.boldText && <b> {item.boldText}</b>}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default withTranslation()(StaffHelpGuide);
